<template>
  <div id="custom_template">
    <div id="header">
      <h2 id="logo">
        <img src="./img/logo.png" />
      </h2>
    </div>

    <div class="content">
      <div id="question">
        <input type="button" class="huge" value="Hotel Guest" name="guest" />
        <input type="button" class="huge" value="Club Member" name="founder" />
        <input type="button" class="huge" value="Resident" name="resident" />
        <input type="button" class="huge" value="Visitor" name="non-guest" />
      </div>

      <div id="forms">
        <form id="guests">
          <h3>HOTEL GUEST WIFI ACCESS</h3>

          <div class="form-wrap last-name text-wrap">
            <table class="table">
              <tbody>
                <tr>
                  <td class="label">Last Name</td>
                  <td>
                    <input
                      type="text"
                      name="last_name"
                      id="last_name"
                      class="text"
                      value=""
                      v-model="form.last_name"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label">Suite Number</td>
                  <td>
                    <input
                      type="text"
                      name="room_number"
                      id="room_number"
                      class="text mini"
                      value=""
                      v-model="form.room_number"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label">&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td class="toc-input">
                    <input
                      type="checkbox"
                      name="toc"
                      id="guestToc"
                      value="true"
                      v-model="form.terms"
                    />
                  </td>
                  <td class="toc-agree">
                    <label for="formToc">
                      I agree to the
                      <a href="#" @click="changeSelectedTOS()"
                        >Terms and Conditions</a
                      ></label
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="button">
            <input
              type="button"
              name="continue"
              id="guestButton"
              value="Agree"
              @click="emitRegistrationMethodData(2)"
            />
          </div>
          <p class="backbutton">
            <a href="#" class="button">Back.</a>
          </p>
          <div v-html="terms_of_service" v-if="doc.selected_tos"></div>
        </form>
        <form id="founders">
          <h3>AMAN CLUB WIFI ACCESS</h3>

          <div class="form-wrap last-name text-wrap">
            <table class="table">
              <tbody>
                <tr>
                  <td class="label">Access Code</td>
                  <td>
                    <input
                      type="text"
                      name="access_code"
                      id="access_code"
                      class="text mini"
                      value=""
                      v-model="form.access_code"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="label">&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td class="toc-input">
                    <input
                      type="checkbox"
                      name="toc"
                      id="guestToc"
                      value="yes"
                      v-model="form.terms"
                    />
                  </td>
                  <td class="toc-agree">
                    <label for="formToc">
                      I agree to the
                      <a href="#" @click="changeSelectedTOS()"
                        >Terms and Conditions</a
                      ></label
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="button">
            <input
              type="button"
              name="continue"
              id="founderButton"
              value="Agree"
              @click="emitRegistrationMethodData(4)"
            />
          </div>
          <p class="backbutton">
            <a href="#" class="button">Back.</a>
          </p>
          <div v-html="terms_of_service" v-if="doc.selected_tos"></div>
        </form>

        <form id="residents">
          <h3>AMAN NEW YORK RESIDENT WIFI ACCESS</h3>

          <div class="form-wrap last-name text-wrap">
            <table class="table">
              <tbody>
                <td class="label">Access Code</td>
                <td>
                  <input
                    type="text"
                    name="access_code"
                    id="access_code"
                    class="text mini"
                    value=""
                    v-model="form.access_code"
                  />
                </td>
                <tr>
                  <td class="label">&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr>
                  <td class="toc-input">
                    <input
                      type="checkbox"
                      name="toc"
                      id="guestToc"
                      value="yes"
                      v-model="form.terms"
                    />
                  </td>
                  <td class="toc-agree">
                    <label for="formToc">
                      I agree to the
                      <a href="#" @click="changeSelectedTOS()"
                        >Terms and Conditions</a
                      ></label
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="button">
            <input
              type="button"
              name="continue"
              id="residentButton"
              value="Agree"
              @click="emitRegistrationMethodData(4)"
            />
          </div>
          <p class="backbutton">
            <a href="#" class="button">Back.</a>
          </p>
          <div v-html="terms_of_service" v-if="doc.selected_tos"></div>
        </form>
        <form id="non-guests" action="#" method="post">
          <h3>VISITOR WIFI ACCESS</h3>

          <div class="form-wrap last-name text-wrap">
            <table class="table">
              <tbody>
                <tr>
                  <td class="label">Email Address</td>
                  <td>
                    <input
                      type="text"
                      name="email_address"
                      id="v_email_address"
                      class="text mini"
                      value=""
                      v-model="form.email_address"
                    />
                  </td>
                </tr>

                <tr>
                  <td class="emailbox-input">
                    <input
                      type="checkbox"
                      name="emailbox"
                      v-model="form.newsletter_signup"
                      id="emailbox"
                    />
                  </td>
                  <td class="emailbox-label">
                    <label for="emailbox"
                      >I would like to receive information about Aman</label>
                  </td>
                </tr>
                <tr>
                  <td class="label">&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                <tr class="tr-or">
                  <td class="label">
                    <input
                      type="hidden"
                      name="newsletter_signup"
                      id="newsletter_signup"
                      value="true"
                      v-model="form.newsletter_signup"
                    />
                  </td>
                </tr>
                <tr>
                  <td class="toc-input">
                    <input
                      type="checkbox"
                      name="toc"
                      id="visitorToc"
                      value="yes"
                      v-model="form.terms"
                    />
                  </td>
                  <td class="toc-agree">
                    <label for="formToc">
                      I agree to the
                      <a href="#" @click="changeSelectedTOS()"
                        >Terms and Conditions</a
                      ></label
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <p v-if="termsWarning" class="terms-warning">
              You must accept the terms of service.
            </p>
          </div>
          <div class="button">
            <input
              type="button"
              name="continue"
              id="visitorButton"
              value="Agree"
              @click="emitRegistrationMethodData(3)"
            />
          </div>
          <p class="backbutton">
            <a href="#" class="button">Back.</a>
          </p>
          <div v-html="terms_of_service" v-if="doc.selected_tos"></div>
        </form>
      </div>
    </div>

    <div id="footer">
      <div class="device-info">
        <b>24/7 Internet Support:</b> 1-855-324-4742
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import Axios from "axios";

export default {
  name: "custom_template",
  props: ["portal", "connection_data"],
  components: {
    // 'registration-method': RegistrationMethod,
  },
  watch: {
    // Collapse the Terms of Service when registration method changes
    "doc.selected_rm": function () {
      this.doc.selected_tos = null;
    },
  },
  data() {
    return {
      access_code: null,
      access_code_valid: true,
      access_code_error_text: "Required",
      form: {
        reg_method: "resident",
        first_name: "",
        last_name: "",
        email_address: "",
        room_number: "",
        access_code: "",
        terms: false,
        newsletter_signup: false,
      },
      termsWarning: false,
      doc: {
        window_width: window.innerWidth,
        selected_rm: null,
        selected_tos: null,
        selected_inline_image: 0,
        selected_background_image: 0,
        support_phone: "8772822519",
      },
      registration_methods: [],
      // Manually setting this up here because not in endpoint
      terms_of_service: `<center><b>TERMS AND CONDITIONS<br>OF INTERNET USE</b><br><br><b>IMPORTANT! PLEASE READ CAREFULLY BEFORE USING. YOUR USE OF THE SERVICES IS YOUR ACKNOWLEDGMENT AND AGREEMENT THAT YOU AGREE WITH THE TERMS SET FORTH BELOW.</b></center><br><br><b>ACCEPTANCE OF TERMS THROUGH USE</b><br>By using these services (the "Services"), you agree to all terms, conditions, and notices contained herein. The Hotel reserves the right, in its sole discretion, to terminate your access to all or part of the Services, with or without notice.<br><br><b>DISCLAIMER OF WARRANTIES</b><br>ALL MATERIALS, INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR AVAILABLE BY THE HOTEL ARE PROVIDED "AS IS". THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES ACCEPT NO LIABILITY FOR ANY PROBLEMS ASSOCIATED WITH YOUR USE OF THE SERVICES, INCLUDING, BUT NOT LIMITED TO, DAMAGE TO YOUR SOFTWARE, HARDWARE, OR OTHER EQUIPMENT; ANY DELAY IN OPERATION OR TRANSMISSION OF THE SERVICES; ANY COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION; ANY PROBLEMS OR TECHNICAL MALFUNCTION OF ANY TELEPHONE NETWORK OR LINES, COMPUTER ON-LINE SYSTEMS, SERVERS, PROVIDERS, OR COMPUTER EQUIPMENT; OR ANY TRAFFIC CONGESTION OF FAILURE OF THE INTERNET OR ANY WEB SITE. THE SERVICES ARE PROVIDED WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NONINFRINGEMENT. THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER, AND ITS REPRESENTATIVES DO NOT WARRANT THAT THE SERVICES ARE ACCURATE, RELIABLE OR CORRECT; THAT THE SERVICES WILL BE UNINTERRUPTED OR AVAILABLE AT ANY PARTICULAR TIME OR LOCATION; THAT THE SERVICES ARE SECURE OR THAT ANY WIRELESS OR WIRED CONNECTION WILL NOT BE ACCESSED, INTERCEPTED, ALTERED OR DESTROYED IN WHOLE OR IN PART BY AN UNAUTHORIZED THIRD PARTY; THAT ANY DATA FILES, PROGRAMS, PROCEDURES OR INFORMATION (INCLUDING YOUR PERSONALLY IDENTIFIABLE INFORMATION) DOWNLOADED, RECORDED, TRANSMITTED OR INPUT THROUGH THE SERVICES WILL BE SECURE OR PROTECTED FROM UNAUTHORIZED ACCESS TO, ALTERATION, DELETION, DEFECT OR DESTRUCTION; THAT ANY DEFECTS OR ERRORS WILL BE CORRECTED; OR THAT THE CONTENT OR SERVICES ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. SOME JURISDICTIONS DO NOT PERMIT THE EXCLUSION OF CERTAIN WARRANTIES, SO THESE EXCLUSIONS MAY NOT APPLY TO YOU.<br><br><b>LIMITATION OF LIABILITY</b><br>UNDER NO CIRCUMSTANCES SHALL THE HOTEL, ITS SUBSIDIARIES, AFFILIATES, OWNER OR ITS REPRESENTATIVES BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM THE USE OF OR INABILITY TO USE, THE SERVICES. THIS LIMITATION APPLIES EVEN IF THE HOTEL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE HOTEL'S LIABILITY IN SUCH JURISDICTIONS SHALL BE LIMITED TO THE MAXIMUM EXTENT PERMITTED BY LAW.<br><br><b>INDEMNIFICATION</b><br>You shall defend, indemnify and hold the Hotel and its owners, subsidiaries and other affiliated companies, and their employees, contractors, officers, and directors harmless from all liabilities, claims, and expenses, including attorney's fees resulting from your use or misuse of the Services.<br><br><b>THIRD PARTY SITES</b><br>Your use of the Services may business center you to other sites on the Internet. These sites may contain information or material that some people may find inappropriate or offensive. These other sites are not under the control of the Hotel, and you acknowledge that the Hotel is not responsible for the accuracy, legality, decency, or any other aspect of the content of such sites. The inclusion of such a business center does not imply endorsement of the site by the Hotel.<br><br><b>RULES OF CONDUCT</b><br>You agree not to use these Services for unlawful purposes or in an offensive manner, including, without limitation, usage that (i) is threatening, abusive, harassing, defamatory, libelous, deceptive, fraudulent, invasive of another's privacy, tortious, or (ii) contains language (sexual or otherwise) of a violent or threatening nature directed at another individual or group of individuals, or victimizes, harasses, degrades, or intimidates an individual or group of individuals on the basis of religion, gender, sexual orientation, race, ethnicity, age, or disability. You shall also be prohibited from usage that infringes any patent, trademark, trade secret, copyright, right of publicity, or other proprietary right of any party (collectively, "Intellectual Property"). You shall not introduce any software viruses or any other computer code, files, or programs that are designed or intended to disrupt, damage, or limit the functioning of any software, hardware, or telecommunications equipment or to damage or obtain unauthorized access to any data or other information of any third party. You further agree that you will not knowingly solicit or collect personal information from a minor (anyone under 18 yrs old) without appropriate prior verifiable parental consent. The Hotel makes no representation that materials accessed through the Service are appropriate or available for use in locations outside the United States, and accessing them from territories where their contents are illegal is prohibited.<br><br><b>MONITORING</b><br>The Hotel, its subsidiaries, affiliates, owner or its representatives have no obligation to monitor, track, record, store or disclose your use of the Services, including, without limitation, the URLs of the websites you visit and the data you enter, transmit, or receive, but may do so (i) to comply with legal or regulatory requirements or to assist in law enforcement investigations and procedures; (ii) to operate the Services properly; (iii) to ensure compliance with the terms and conditions herein; or (iv) based on a good faith belief that such monitoring, tracking, recording, storing, or disclosure is otherwise necessary or advisable including, without limitation, if there is reason to believe that such information is necessary to identify, contact or bring legal action against someone who may be causing interference with our rights or properties, whether intentionally or otherwise, or when anyone else could be harmed by such activities.<br><br><b>PROPRIETARY RIGHTS</b><br>You acknowledge and agree that all content and materials available to you through these Services are protected by Intellectual Property rights and laws. Reproduction, copying, or redistribution for commercial purposes of any materials or design elements obtained through these Services is strictly prohibited without the express written permission of Intellectual Property owner.<br><br><b>REVISIONS</b><br>The Hotel reserves the right, in it sole discretion, to update or revise these terms from time to time.`,
    };
  },
  filters: {
    phone: function (value) {
      if (!value) return "";
      value = value.toString();
      return (
        "(" +
        value.substr(0, 3) +
        ") " +
        value.substr(3, 3) +
        "-" +
        value.substr(6, 4)
      );
    },
  },
  mounted() {
    if (this.portal.template.support_phone) {
      this.doc.support_phone = this.portal.template.support_phone;
    }

    this.generateRegistrationMethods();

    $("#question > input").click(function (e) {
      var $btn = this;
      e.preventDefault();
      $("#question").fadeOut(400, function () {
        if ($btn.value === "Hotel Guest") {
          $("#guests").addClass("visible");
        } else if ($btn.value === "Club Member") {
          $("#founders").addClass("visible");
        } else if ($btn.value === "Resident") {
          $("#residents").addClass("visible");
        } else {
          $("#non-guests").addClass("visible");
        }
      });
    });

    $(".backbutton > a").click(function (e) {
      e.preventDefault();
      $("form").removeClass("visible");
      $("#question").fadeIn(400);
    });

    $(".email_holder").hide();
    $("#guest_emailbox").change(function () {
      if ($(this).prop("checked")) {
        $(".email_holder").show();
      } else {
        $(".email_holder").hide();
      }
    });
  },
  methods: {
    generateRegistrationMethods: function () {
      for (var i in this.portal.registration_methods) {
        var rm = this.portal.registration_methods[i];
        for (var c in rm.rate_plans) {
          var rateplan = rm.rate_plans[c];
          var plan = {
            name:
              rm.free == 0 ? rateplan.rate_plan_name : rm.registration_method,
            type: "rateplan",
            registration_method_id: rm.registration_method_id,
            id: rateplan.rateplan_id,
            price: rateplan.price,
            duration: rateplan.duration,
            speed_upload: rateplan.speed_upload,
            speed_download: rateplan.speed_download,
            additional_devices: rateplan.additional_devices,
            terms_of_service: this.terms_of_service,
          };
          this.registration_methods.push(plan);
        }
      }
      if (this.portal.access_codes.length > 0) {
        plan = {
          name: "Access Code",
          type: "accesscode",
          registration_method_id: 4,
          terms_of_service: this.terms_of_service,
        };
        this.registration_methods.push(plan);
      }
      if (this.registration_methods.length == 1) {
        this.doc.selected_rm = 0;
      }
    },
    // Change selected registration method from emitted data
    changeSelected: function (index) {
      this.doc.selected_rm = index;
    },
    // Change selected terms of service from emitted data
    changeSelectedTOS: function () {
      if (this.doc.selected_tos) {
        this.doc.selected_tos = null;
      } else {
        this.doc.selected_tos = true;
      }
    },
    // Send registration method details back to parent
    emitRegistrationMethodData: function (rm_id) {
      
      // get the registration method based on the form submitted
      let reg_method = this.registration_methods.filter(function (rm) {
        return rm.registration_method_id == rm_id;
      });

      this.registration_method = reg_method[0];
      
      if (
        this.registration_method.type == "accesscode" &&
        !this.form.access_code
      ) {
        this.access_code_valid = false;
        return;
      }
      if (this.clicked) {
        return;
      }

      this.clicked = true;

      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };

      if (this.registration_method.registration_method_id == "1") {
        emitted.rateplan_id = this.registration_method.id;
      } else if (this.registration_method.registration_method_id == "2") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
        if (this.form.email_address) {
          emitted.email_address = this.form.email_address;
        }
      } else if (this.registration_method.registration_method_id == "3") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.first_name = this.form.first_name;
        emitted.last_name = this.form.last_name;
        emitted.email_address = this.form.email_address;
      } else if (this.registration_method.registration_method_id == "4") {
        emitted.access_code = this.form.access_code;
      }

      if (this.form.newsletter_signup) {
        emitted.marketing_consent = 1;
      }
      
      if (this.form.terms) {
        this.$emit("emitRegistrationMethodData", emitted);
      } else {
        this.termsWarning = true;
        // unset the clicked flag if they attempt a registration without accepting terms
        this.clicked = false;
      }
    },
  },
};
</script>

<style>
@font-face {
  font-family: 'Lyon';
  src: url('./fonts/Lyon.otf') format('opentype');
}
/* ==========================================================================
   HTML5 Boilerplate styles - h5bp.com (generated via initializr.com)
   ========================================================================== */

html,
button,
input,
select,
textarea {
  color: #222;
}

body {
  font-size: 1em;
  line-height: 1.4;
  background: #f3eee7;
  color: #313131;
}

::-moz-selection {
  background: #b3d4fc;
  text-shadow: none;
}

::selection {
  background: #b3d4fc;
  text-shadow: none;
}
#logo img {
  max-width: 240px;
  margin-bottom: 45px;
}
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
  margin: 1em 0;
  padding: 0;
}

img {
  vertical-align: middle;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

textarea {
  resize: vertical;
}

.chromeframe {
  margin: 0.2em 0;
  background: #ccc;
  color: #000;
  padding: 0.2em 0;
}

/* ==========================================================================
   Author's custom styles
   ========================================================================== */

html,
body {
  width: auto;
  height: 100%;
}

html, #app {
  font-family: "Lyon", serif;
}

#guestButton,
#visitorButton,
#founderButton,
#residentButton {
  background: #313131;
  color: #f3eee7;
}
body {
  text-align: center;
  font-family: "Lyon", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

h1 a,
h2 a {
  display: inline-block;
  clear: both;
}

.email_holder {
  display: none;
}

#dtlalogo a {
  width: 491px;
  height: 119px;
  background: url("./img/logo.png") no-repeat center center;
}

.content {
  text-align: left;
  width: 80%;
  max-width: 900px;
  padding: 1em 2em;
  margin: 0 auto 0 auto;
  /*  background: rgba(255,255,255,0.3);*/
}

.emailbox-input {
  text-align: right;
}
.emailbox-label {
  font-size: 14px;
}

#footer {
  padding: 0 0 40px 0;
}

a:link,
a:visited {
  color: #000;
  
}

.text-wrap {
  width: 100%;
  margin: 0 0 20px 0;
}
.text-wrap-end {
  margin-bottom: 0;
}
.table {
  width: 100%;
}
.table tr td {
  padding: 2px 5px;
}
.table tr td:first-child {
  width: 115px;
  padding-right: 10px;
}
.table tr.tr-or td:nth-child(2) {
  font-size: 12px;
}
.toc {
  clear: both;
  float: left;
  max-height: 200px;
  overflow-y: scroll;
  padding: 20px;
  margin: 0 20px 20px 20px;
  font-size: 12px;
  background: #e8e8e8;
}
.toc b {
  
}
.toc-input {
  text-align: right;
}
.errors {
  display: block;
  margin: 0 20px 20px 20px;
  padding-left: 15px;
  list-style: disc inside;
}
.errors li {
}
.toc-agree {
  clear: both;
  margin: 0 0 10px 0;
  padding: 0 20px;
  font-size: 14px;
  text-align: left;
}
.toc-agree input {
  margin-right: 5px;
}
.text {
  width: 95%;
  font-size: 16px;
  padding: 10px 2.5%;
  text-align: left;
}
.button {
  width: 100%;
  text-align: center;
}
.button input {
  width: 160px;
  padding: 10px 0;
  min-height: 36px;
  border: none !important;
}
form h3 {
  text-align: center;
}
.form-wrap table {
  width: 50%;
  margin: 0 auto;
}
.device-info {
  margin: 20px 0 0 0;
  font-size: 14px;
  text-align: center;
}
#timeRemaining {
  display: block;
  width: 100%;
  height: 90px;
}
/* jQuery Countdown styles 1.6.1. */
.hasCountdown {
}
.countdown_rtl {
  direction: rtl;
}
.countdown_holding span {
  color: #6b6b6b;
}
.countdown_row {
  clear: both;
  width: 100%;
  padding: 0px 2px;
  text-align: center;
}
.countdown_show1 .countdown_section {
  width: 98%;
}
.countdown_show2 .countdown_section {
  width: 48%;
}
.countdown_show3 .countdown_section {
  width: 32.5%;
}
.countdown_show4 .countdown_section {
  width: 24.5%;
}
.countdown_show5 .countdown_section {
  width: 19.5%;
}
.countdown_show6 .countdown_section {
  width: 16.25%;
}
.countdown_show7 .countdown_section {
  width: 14%;
}
.countdown_section {
  display: block;
  float: left;
  font-size: 100%;
  text-align: center;
}
h3{
  font-weight: unset !important;
}
.countdown_amount {
  font-size: 200%;
  font-weight: normal;
}
.countdown_descr {
  display: block;
  width: 100%;
}

/* ==========================================================================
   Dynamic form styles
   ========================================================================== */
#question {
  font-size: 1em;
  text-align: center;
  margin-top: 45px;
}

#question input {
  margin-right: 25px;
}

#footer {
}
.huge {
  letter-spacing: 1px;
  font-family: "Lyon", serif;
  font-size: 1.2em;
  line-height: 60px;
  height: 60px;
  padding: 0 10px;
  min-width: 180px;
  margin-bottom: 10px;
}
.huge {
  border: 2px solid rgba(0, 0, 0, 0.5);
  color: rgba(0, 0, 0, 0.7);
  background: none;
}
.huge:hover {
  border: 2px solid rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, 1);
}
.huge:active {
  background: rgba(0, 0, 0, 0.1);
}
form {
  display: none;
}
form.visible {
  display: block;
}
.backbutton {
  margin-top: 60px;
  text-align: center;
}
.backbutton a {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
  font-weight: normal;
}
.backbutton a:hover {
  color: rgba(0, 0, 0, 1);
  text-decoration: underline;
}

.terms-warning {
  text-align: center;
  color: red;
}
/* ==========================================================================
   Media Queries
   ========================================================================== */

@media only screen and (max-width: 35em) {
  #dtlalogo a {
    width: 300px;
    height: 73px;
    background-size: 300px 73px;
  }

  .content {
    padding: 0;
    margin: 20px auto 0 auto;
  }

  #footer {
    padding: 0 0 20px 0;
  }

  textarea,
  input[type="text"],
  input[type="email"],
  input[type="password"] {
    min-width: 0px;
    width: auto;
  }
  input[type="button"].huge {
    margin-right: 25px;
  }

  ,
  .table tr td {
    font-size: 14px;
  }
  .table tr td:first-child {
    width: 90px;
  }
  .device-info {
    font-size: 12px;
  }
  #timeRemaining {
    font-size: 80%;
  }
}

@media print,
  (-o-min-device-pixel-ratio: 5/4),
  (-webkit-min-device-pixel-ratio: 1.25),
  (min-resolution: 120dpi) {
}

/* ==========================================================================
   Helper classes
   ========================================================================== */

.ir {
  background-color: transparent;
  border: 0;
  overflow: hidden;
  *text-indent: -9999px;
}

.ir:before {
  content: "";
  display: block;
  width: 0;
  height: 150%;
}

.hidden {
  display: none !important;
  visibility: hidden;
}

.visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

.invisible {
  visibility: hidden;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

.clearfix {
  *zoom: 1;
}

/* ==========================================================================
   Print styles
   ========================================================================== */

@media print {
  * {
    background: transparent !important;
    color: #000 !important; /* Black prints faster: h5bp.com/s */
    box-shadow: none !important;
    text-shadow: none !important;
  }

  a,
  a:visited {
    text-decoration: underline;
  }

  a[href]:after {
    content: " (" attr(href) ")";
  }

  abbr[title]:after {
    content: " (" attr(title) ")";
  }

  /*
     * Don't show links for images, or javascript/internal links
     */

  .ir a:after,
  a[href^="javascript:"]:after,
  a[href^="#"]:after {
    content: "";
  }

  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group; /* h5bp.com/t */
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  img {
    max-width: 100% !important;
  }

  @page {
    margin: 0.5cm;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }
}
</style>
